"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.INJECT_FOLLOWED_DOMAINS_KEY = void 0;
exports.INJECT_FOLLOWED_DOMAINS_KEY = 'linkFollowedDomains';
